
export class AccountNumber {
    contractNumber: string
    scheduleNumber: string
    contractType: string
}
